export default __webpack_public_path__ + "images/6d3454af432d901c519ce6c648728efc-gift-icon.svg";